import {TicketStatusId} from '@app/shared/services';
import {Injectable} from "@angular/core";


@Injectable()
export class TicketActionStateManager<T> {
  private executingAction: T | null = null;

  constructor(private executableActionGroupsByStatusId: Map<TicketStatusId | null, Set<T>>) { }

  setExecutingAction(action: T, executing: boolean) {
    this.executingAction = executing ? action : null;
  }

  isActionInProgress(): boolean {
    return this.executingAction != null;
  }

  isActionExecuting(action: T): boolean {
    return this.executingAction === action;
  }

  isActionAvailable(action: T, ticketStatusId: TicketStatusId | null): boolean {
    return (this.executableActionGroupsByStatusId.get(ticketStatusId)?.has(action) ?? false);
  }
}
